import { Grid } from "@progress/kendo-react-grid";
import styled from "styled-components";

export const StyledSortableGrid = styled(Grid)`
  .k-column-title {
    min-width: 0;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    overflow: hidden;
    font-weight: bold;
    font-family: "Roboto";
  }
  ,
  th {
    border-inline-start-width: 0px !important;
  }
  th > .k-cell-inner > .k-link {
    border-right: 2px solid var(--kendo-color-border);
    justify-content: center;
  }
  ,
  th > .k-cell-inner,
  .k-grid-header-wrap {
    background-color: white;
    height: 55px;
  }
  ,
  .k-table-row,
  .k-table-alt-row,
  .k-grid-table-wrap {
    background-color: #f3f4f6 !important;
  }
  ,
  .k-table-td {
    border-bottom: 1px solid var(--kendo-color-border);
    border-left: none;
    border-right: none;
    font-family: "Roboto";
    text-align: center;
  }
  .k-grid tr {
    background-color: #ffffff;
  }
  .k-grid tr.k-alt {
    background-color: #ffffff;
  }
  k-grid .k-table-row.k-table-alt-row {
    background-color: #f9f9f9;
  }
  .k-sort-icon,
  .k-sort-icon .k-icon,
  .k-sort-icon svg {
    color: #6c757d;
    fill: #6c757d;
  }
`;
